<template>
  <div class="leave-content-item" v-show="isCurrentContentItem" v-bitmap="getListResult">
    <leaveList
      :leaveList="leaveList"
      class="leave-list-content-main"
      :leaveStatus="currentStatus"
      @updateStatus="updateStatus"
    />
    <pagination
      :pageSize="pageSize"
      :total="total"
      @currentPageNumChange="currentPageNumChange"
      @handleSizeChange="handleSizeChange"
    ></pagination>
  </div>
</template>

<script>
import leaveList from "../leave-list/leave-list.vue";

export default {
  data() {
    return {
      total: 0,
      pageSize: 10,
      pageNum: 1,
      leaveList: null,
      getListResult: "nullData",
    };
  },
  components: {
    leaveList,
  },
  props: {
    isCurrentContentItem: {
      type: Boolean,
    },
    currentStatus: {
      type: Number,
      require: true,
    },
    startTime: {
      type: String,
    },
    endTime: {
      type: String,
    },
    leaveType: {
      type: String,
    },
    changeStatus: {
      type: Number,
    },
    classData: {
      type: Object,
    },
  },
  watch: {
    isCurrentContentItem: {
      handler(val) {
        if (val && !this.leaveList && this.changeStatus) {
          this.getLeaveList();
        }
      },
      immediate: true,
    },
    startTime() {
      this.leaveList = null;
      if (this.isCurrentContentItem) {
        this.getLeaveList();
      }
    },
    endTime() {
      this.leaveList = null;
      if (this.isCurrentContentItem) {
        this.getLeaveList();
      }
    },
    leaveType() {
      this.leaveList = null;
      if (this.isCurrentContentItem) {
        this.getLeaveList();
      }
    },
    changeStatus: {
      handler(val) {
        if (val) {
          this.leaveList = null;
          if (this.isCurrentContentItem) {
            this.getLeaveList();
          }
        }
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {},
  methods: {
    getLeaveList() {
      // this.getListResult = "loading";
      this.post(this.$url.selectStudentLeaveListByFiltrate, {
        classId: this.classData.classId, //班级id
        status: this.currentStatus, //审核状态(1审批中 2审批通过 3审批拒绝)
        startTime: this.startTime,
        endTime: this.endTime,
        leaveType: this.leaveType, //请假事由(1事假 2病假 3休学 4其他)
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      })
        .then((res) => {
          // console.log("获取请假列表:", res);
          if (res.code != 200) {
            this.getListResult = "error";
            this.$message.error("获取请假列表失败！");
            return;
          }

          let data = res;
          this.total = data.total;
          this.leaveList = data.rows;
          this.total > 0
            ? (this.getListResult = "success")
            : (this.getListResult = "nullData");
        })
        .catch((err) => {
          this.getListResult = "error";
          this.$message.error("获取请假列表失败，请稍后再试");
        });
    },
    currentPageNumChange(e) {
      this.pageNum = e;
      this.getLeaveList();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getLeaveList();
    },
    updateStatus(e) {
      this.$emit("updateStatus", e);
    },
  },
};
</script>

<style lang="sass" scoped>
@import "./leave-content-item.scss"
</style>
